import $ from 'jquery';

const renderPricing = () => {
	const packageType = $('input[name=package_type]:checked').val();
	const isConsumer = packageType === 'consumer';
	const years =
		$('input[name=pricing_duration_value]:checked').val() == 1
			? 'one'
			: 'two';
	const totalPrice = isConsumer
		? $('input[data-individual-consumer]').data('price-' + years + '-year')
		: $('input[name=pricing_employee_value]:checked').data(
				'price-' + years + '-year'
		  );

	$('#js-hide-me-on-consumer').css('display', isConsumer ? 'none' : 'block');
	$('#js-pricing-total').text(totalPrice);
	$('#js-pricing-total-value').val(totalPrice);
};

$('.js-pricing-label').on('click', function () {
	setTimeout(renderPricing, 0);
});

renderPricing();

$('.js-submit-form').on('submit', function (event) {
	event.preventDefault();
	const $form = $(this);
	const formValues = $form.serialize();
	$.post($form.attr('action'), formValues, function (data) {
		if (data?.html ?? false)
			$form.html(`<div class="mx-auto w-850 mw-100 text-body p-4 card shadow py-lg-8 px-lg-9 text-center">
				${data?.html}
			</div>`);
		else
			$form.html(
				'<div class="mx-auto w-850 mw-100 text-body p-4 card shadow py-lg-8 px-lg-9 text-center"><h3>Dank voor je aanvraag.</h3><p>Tot snel!</p></div>'
			);
	}).fail(function (data) {
		if (data?.responseJSON?.html ?? false)
			$form.html(`<div class="mx-auto w-850 mw-100 text-body p-4 card shadow py-lg-8 px-lg-9 text-center">
				${data.responseJSON.html}
			</div>`);
		else
			$form.html(
				'<div class="mx-auto w-850 mw-100 text-body p-4 card shadow py-lg-8 px-lg-9 text-center"><h3>Er is iets mis gegaan.</h3><p>Probeer het later opnieuw.</p></div>'
			);
	});
});
